export function mergeObjects(obj1, obj2) {
    const obj3 = {};
    let attrname;
    for (attrname in obj1) {
        obj3[attrname] = obj1[attrname];
    }
    for (attrname in obj2) {
        obj3[attrname] = obj2[attrname];
    }
    return obj3;
}

export function iCoreForEach(arr, callback, onDoneCallback) {
    // in case arr is an empty query selector node list
    if (arr) {
        for (let i = 0, len = arr.length; i < len; i++) {
            callback(arr[i], i);
        }
    }

    if (typeof onDoneCallback === "function") {
        onDoneCallback();
    }
}

export function fragmentToString(fragment) {
    const serializer = new XMLSerializer();
    return Array.from(fragment.childNodes).map(node => serializer.serializeToString(node)).join('');
}

export function strToHtml(str) {
    let parsed = new DOMParser().parseFromString(str, 'text/html');
    if (parsed.body.firstChild) {
        return parsed.body.firstChild;
    }
    return parsed.head.firstChild;
}

export function isMobile(mode = 'smartphone') {
    switch (mode.toLowerCase()) {
        case 'blackberry':
            return window.matchMedia('(min-width: 600px) and (max-width: 767px)').matches;
        default:
            return window.matchMedia('(max-width: 599px)').matches;
    }
}

export function isTablet(mode = 'ipadpro') {
    switch (mode.toLowerCase()) {
        case 'ipadmini':
            return window.matchMedia('(min-width: 768px) and (max-width: 899px)').matches;
        default:
            return window.matchMedia('(min-width: 900px) and (max-width: 1024px)').matches;
    }
}